<ng-container *ngIf="isLoaded as loaded; else loading">
    <div class="paperwork" *ngIf="documentaryEvidence && documentaryEvidence.length === 0">
        <div class="paperwork_empty">
            <p>De map is leeg, omdat deze informatie voor uw claim niet nodig is.</p>
        </div>
    </div>
    <div class="paperwork" *ngIf="documentaryEvidence">
        <div class="paperwork__header" *ngIf="buttonSubmit?.knop_status === 'zichtbaar'">
            <p>Om uw schademelding af te handelen hebben wij de volgende documenten van u nodig:</p>
            <list-flat>
                <list-flat-item class="paperwork__highlighted-text" *ngFor="let bewijsstuk of documentaryEvidence">
                    <span>
                        <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#bullet"></use></svg>
                    </span>
                    <span>{{ bewijsstuk.document_omschrijving }}</span>
                </list-flat-item>
            </list-flat>
            <h4>Hoe werkt het uploaden?</h4>
            <list-flat class="paperwork__list-flat" [numbered]="true">
                <list-flat-item class="paperwork__list-item">Maak een scan of foto van uw document(en)</list-flat-item>
                <list-flat-item class="paperwork__list-item">
                    Sla het bestand op (maximaal 25MB) als .pdf, .png, .jpg, .bmp, .tiff, .doc, .docx, .ppt of .pptx.
                </list-flat-item>
                <list-flat-item class="paperwork__list-item">
                    Klik op de knop "Selecteer" om uw document(en) te selecteren en te uploaden.
                </list-flat-item>
                <list-flat-item class="paperwork__list-item">
                    Als het uploaden niet lukt, stuur dan de documenten per email naar schadeteam&#64;inshared.nl.
                    Vermeld in de onderwerpregel uw relatie- of schadenummer. Deze vind u in uw Verzekeringsmap onder
                    ‘Schades’ of in de bevestiging van uw schademelding.
                </list-flat-item>
            </list-flat>
        </div>

        <div class="paperwork_upload" *ngFor="let bewijsstuk of documentaryEvidence; index as i">
            <ins-documentary-evidence
                class="paperwork__evidence"
                [evidenceIndex]="i"
                [evidenceDocuments]="bewijsstuk"
                [submitted]="buttonSubmit?.knop_status !== 'zichtbaar'"
            ></ins-documentary-evidence>
        </div>

        <cyno-alert [meldingen]="messages" *ngIf="messages"></cyno-alert>

        <div class="paperwork__explanation" *ngIf="buttonSubmit?.knop_status === 'zichtbaar'">
            <div class="paperwork__explanation-item">
                <span>
                    Lukt het uploaden niet? Dan kunt u ook de documenten opsturen naar
                    <span class="paperwork__mail">schadeteam&#64;inshared.nl</span>
                    . Vermeld dan wel uw relatienummer (uit uw Verzekeringsmap) in de onderwerpregel.
                </span>
            </div>
            <div class="paperwork__explanation-item">
                <button
                    class="paperwork__explanation-button btn btn--primary"
                    [ngClass]="{ disabled: isLoading }"
                    (click)="onSubmit()"
                >
                    Indienen
                </button>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #loading>
    <div class="skeleton-loader__line no-float"></div>
    <div class="skeleton-loader__line no-float"></div>
    <div class="skeleton-loader__line skeleton-loader__line--half no-float"></div>
    <div class="skeleton-loader__line no-float"></div>
    <div class="skeleton-loader__line skeleton-loader__line--half no-float"></div>
    <div class="skeleton-loader__line no-float"></div>
</ng-template>
